// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.order-menu-dropdown{z-index:2947483627 !important}`, "",{"version":3,"sources":["webpack://./src/components/Layout/components/Header/orderMenu.scss"],"names":[],"mappings":"AAAA,qBACE,6BAAA","sourcesContent":[".order-menu-dropdown {\n  z-index: 2947483627 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
